import axios from 'axios';

const UNDECODABLE_CHAIN_INFO = [
    {
        chain: 'iris',
        prefix: 'iaa', 
        type: '/ethermint.types.v1.EthAccount', 
        queryURL: 'https://iris-api.crescent.network/cosmos/auth/v1beta1/accounts/', 
    }
    ,
    {
        chain: 'stride',
        prefix: 'stride', 
        type: '/stride.vesting.StridePeriodicVestingAccount', 
        queryURL: 'https://stride-api.crescent.network/cosmos/auth/v1beta1/accounts/', 
    }
]

export const getAccountInfo = async (address, url, chain) => {
    try {
        const response = await axios.get(`${url}/${address}`)

        if(chain === 'iris') {
            const irisAccountData = response.data.account.base_account
            return {
                address: address,
                pubkey: {type:  irisAccountData.pub_key['@type'], value:irisAccountData.pub_key.key},
                accountNumber: Number(irisAccountData.account_number),
                sequence: Number(irisAccountData.sequence)
            }  
        } else if(chain === 'stride') {
            const strideAccountData = response.data.account.base_vesting_account.base_account
            return {
                address: address,
                pubkey: {type:  strideAccountData.pub_key['@type'], value:strideAccountData.pub_key.key},
                accountNumber: Number(strideAccountData.account_number),
                sequence: Number(strideAccountData.sequence)
            }  
        } else {
            throw new Error(`not supported chain:${chain}`)
        }
    } catch(e) {
        throw new Error(`getAccountInfo: ${e}`)
    }
   
}

export function checkUndecodableAccount(searchAddress, type) {
    return UNDECODABLE_CHAIN_INFO.filter((info) => {
        return (info.type === type) && String(searchAddress).startsWith(info.prefix)
    })   
}